var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-card-image",style:(_vm.componentStyles),on:{"click":function($event){return _vm.clicked()}}},[(_vm.completed)?_c('icon-complete-filled',{attrs:{"size":'sm4'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }